const { isTestEnv } = require("../globals");
function formatNumber(number) {
  // isTestEnv && console.log("format number", number);
  // Check if the number is negative
  if (number < 0) {
    // If negative, return the number with '-' sign on the left side
    return Math.abs(number).toLocaleString() + "-";
  } else if (number >= 0) {
    // If positive or zero, return the number as is
    return Math.abs(number).toLocaleString();
  } else {
    //if null or another string
    return "";
  }
}

function formatDate(dateString) {

  if(dateString == null)
    return null;
  const date = new Date(dateString);

  const day = date.getDate();

  const month = date.getMonth() + 1;

  const year = date.getFullYear();

  return `${day < 10 ? "0" : ""}${day}.${
    month < 10 ? "0" : ""
  }${month}.${year}`;
}

function differenceInMilliseconds(dateString) {
  const curentDate = new Date();
  // console.log("curentDate", curentDate);
  const [day2, month2, year2] = dateString.split(".");
  const date2 = new Date(`${year2}/${month2}/${day2}`);
  // console.log("date2", date2);
  const diff = curentDate - date2;
  // Convert milliseconds to days
  const differenceInDays = Math.floor(diff / (1000 * 60 * 60 * 24));
  return differenceInDays;
}

function getColorForValue(value){
  console.log("getColorForValue", value);
  if (value > 0) return "#FF5733"; // red
  if (value < 0) return "#4CAF50"; // green
  return null; // default color
};


module.exports = {
  formatNumber,
  formatDate,
  differenceInMilliseconds,
  getColorForValue,
};


